import { render, staticRenderFns } from "./SalesmanEvents.vue?vue&type=template&id=2dbf9368&"
import script from "./SalesmanEvents.vue?vue&type=script&lang=js&"
export * from "./SalesmanEvents.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports